import { LAYOUTS, POSITION, } from '@voltmoney/types';
import _ from 'lodash';
import { AmountCardTypeTokens, BottomTabStateToken, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, InterestBounceType, LoanRenewalScenario, ShadowTypeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TagTypeTokens, TypographyTypeDLS, WIDGET, HeaderTypeTokens } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { goBack, learnMoreAction, learnMoreInterest, loanRenewalExpiredRepayment, navigate, navigateToAccountDetails, navigateToInterestRepaymentDetials, navigateToManageLimit, navigateToShortfallDetails, navigateToStatues, navigateToTransactionHistory, navigateTrackLoanClosure, needHelpAction, OpenContactUS, OpenProfile, renewNowAction, reOpenLoanAccount, repayment, requestType, withdrawNow, navToIC, navigateToTransactionsPostRejectionAction, navigateToWithdrawalScreenAction, sdkProcessCompleteCardClose, onWithdrawClickAction, backAction, loanRefundAction } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { getAppHeader, initializeFirebase } from '../../../configs/config';
import { getContactNumberForCall, shouldShowVoltContactUs, showContactus, } from '../../../configs/uri-config-utils';
import { Platform } from 'react-native';
import { addCommasToNumber, addMonthsToEpochTimetamp, addSuffix, getBackgroundColorDashboard, getBorrowerProfile, getDateMonthYearFromEpoch, getDateMonthYearFromEpochInIST, getDateMonthYearFromEpochIst, getDaysDelta, getForeClosureDetails, getISTTime, getManageLimitConfig, getParameters, getPendingCreditRequestByCreditId, getUserContext, INTEREST_REPAYMENT_STATUS, isFromTDLPlatform, mockCurrentDate, returnDateInString, SHOW_NEW_WITHDRAW_FLOW, showInterestCalculatorFlag, showLeinRemovalTrackingFlow, showNewDashboardWithdrawCard, showRepaymentRejectedCard, showShortFallCard, showWithdrawRejectedCard, } from '../../../configs/utils';
import { LENDER_ID, LOAN_RENEWAL_ALLOW_ADMIN, LOAN_RENEWAL_FLOW_SHOW, REPAYMENT_COLLECTION_TYPE, UPDATE_REQUEST_TYPE, UPDATE_STATUS_TYPE } from "../../../configs/constants";
import moment from "moment/moment";
import { navigateToShortfallInfoScreen } from '../shortfall_details/action';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = async (availableCreditAmount, actualLoanAmount, repaymentAmount, isPendingDisbursalApproval, amountPercentage, isPendingDisbursalStatement, isDisbursalRequestAllowed, amountDisbursal, processingFess, isFirstJourney, showContactUs, platform, _user, showPendingUnpledge, fundNumber, isPendingForeclosure, isFromBajaj, pendingArray, userName, showRenewalFlow, renewalDateDelta, renewalAmount, renewalRequestDetailsList, showNewDashboardCard, isLoanContractExpired, overDueAmount, loanExpiryDay, loanExpiryScenario, dueDate, inProgressTransaction, isPendingLoanRenewal, forceAllowPayment, callDeepLink, interestRepaymentType, interestReponse, showInterestRepayment = false, showNewWithdrawFlow, statementLabel, bankDetails, pendingForeclosureStepperData, pendingClosurePlacedDate, isShortfallDue, showShortfallDetails, shortfallAmount, daysLeft, shortfallDetails, showBottomNavBar, profileDetails, showAccountDetails, showTransactionHistory, showManageLimit, showTrackLoanClosure, showBenefitsSection, showMyAccountIcon, showForeclosureTracking, showInterestCalculator, showWithdrawalRejectedCarousal, withdrawalRejectionResponse, shouldShowWithdrawalCard, isCreditStatusActive, showHeaderBackButton, hardBreachDate, softBreachDate, showCta, showInfoSection, isLoanExpired) => {
    return {
        layout: {
            id: ROUTE.DASHBOARD,
            type: LAYOUTS.LIST,
            widgets: (isPendingForeclosure === false &&
                isLoanContractExpired &&
                await LOAN_RENEWAL_FLOW_SHOW() && !isPendingLoanRenewal) ? [
                {
                    id: 'header',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                },
                showWithdrawalRejectedCarousal ? {
                    id: "withdrawalRejectionCard",
                    type: WIDGET.WITHDRAWAL_FAILED_CARD
                } : {},
                showWithdrawalRejectedCarousal ? {
                    id: "space8",
                    type: WIDGET.SPACE,
                } : {},
                ...(isPendingLoanRenewal ||
                    inProgressTransaction) ? [{
                        id: "pdCard",
                        type: WIDGET.PENDING_UNPLEDGE_VIEW
                    }, {
                        id: "space8",
                        type: WIDGET.SPACE
                    }] : [],
                !isPendingLoanRenewal ?
                    {
                        id: "loanRenewalFlowExpiredCard",
                        type: WIDGET.LOAN_RENEWAL_EXPIRED_DASHBOARD_CARD,
                        padding: {
                            horizontal: -16
                        }
                    } : {},
                {
                    id: "space8",
                    type: WIDGET.SPACE
                },
                {
                    id: 'loanExpiryFaqScreenStack',
                    type: WIDGET.STACK,
                    padding: {
                        horizontal: -16
                    }
                },
                { id: "spaceFaq", type: WIDGET.SPACE },
                !showBottomNavBar && (showTransactionHistory || showTrackLoanClosure || showAccountDetails || showManageLimit) ? {
                    id: "manageLoanDetails", type: WIDGET.MANAGE_LOAN_DETAILS
                } : {},
                (platform && platform === 'REDVISION') || !showBottomNavBar ? {} : {
                    id: 'cardNav',
                    type: WIDGET.CARD,
                    position: POSITION.STICKY_BOTTOM,
                    padding: {
                        left: 0,
                        right: 0,
                    },
                },
                isFromTDLPlatform() ? { id: "sdkProcessCompletedCard", type: WIDGET.SDK_PROCESS_COMPLETE_CARD } : {}
            ] : (!isPendingForeclosure || isPendingLoanRenewal) ? [
                showHeaderBackButton ? {
                    id: 'headerCustom',
                    type: WIDGET.CUSTOM_HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                } : {},
                !showHeaderBackButton ? {
                    id: 'header',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                } : {},
                showWithdrawalRejectedCarousal ? {
                    id: "withdrawalRejectionCard",
                    type: WIDGET.WITHDRAWAL_FAILED_CARD
                } : {},
                showWithdrawalRejectedCarousal ? {
                    id: "space8",
                    type: WIDGET.SPACE,
                } : {},
                ...(showPendingUnpledge || isPendingLoanRenewal) ? [{
                        id: "pdCard",
                        type: WIDGET.PENDING_UNPLEDGE_VIEW
                    }] : [],
                (!showRenewalFlow ||
                    pendingArray.length > 0) ? {
                    id: "space8",
                    type: WIDGET.SPACE
                } : {},
                ...((showShortfallDetails && isShortfallDue && shortfallAmount > 0) ?
                    [{
                            id: "shortfallCard",
                            type: WIDGET.SHORTFALL_CARD,
                        }] : []),
                ...((showShortfallDetails && isShortfallDue && !showInterestRepayment && shortfallAmount > 0) ?
                    [{
                            id: "space16",
                            type: WIDGET.SPACE,
                        }] : [{
                        id: "spaceMD",
                        type: WIDGET.SPACE
                    },]),
                ...(showInterestRepayment) ? [{ id: 'spaceInterest', type: WIDGET.SPACE }, {
                        id: 'interestRepaymentText',
                        type: WIDGET.TEXT
                    }] : [],
                ...(showInterestRepayment) ? [{
                        id: 'interestRepaymentCard',
                        type: WIDGET.INTEREST_REPAYMENT_CARD
                    }] : [],
                ...(isPendingDisbursalApproval && !showNewWithdrawFlow
                    ? [
                        {
                            id: 'card2',
                            type: WIDGET.CARD,
                            position: POSITION.FIXED_TOP,
                            padding: {
                                horizontal: -16,
                                top: -12
                            },
                        },
                    ]
                    : []),
                ...(isPendingDisbursalStatement
                    ? [
                        {
                            id: 'message2',
                            type: WIDGET.MESSAGE,
                            position: POSITION.FIXED_TOP,
                            padding: {
                                horizontal: -16,
                            },
                        },
                    ]
                    : []),
                ...showRenewalFlow && await LOAN_RENEWAL_FLOW_SHOW() ? [
                    {
                        id: 'loanRenewalFlowCard',
                        type: WIDGET.LOAN_RENEWAL_DASHBOARD_CARD,
                        padding: {
                            horizontal: -16
                        }
                    },
                    {
                        id: 'loanRenewalFlowCardBottomSpace0',
                        type: WIDGET.SPACE
                    }
                ] : [],
                {
                    id: 'cardItem',
                    type: WIDGET.STACK,
                },
                ...((repaymentAmount > 0 && !showNewDashboardCard)
                    ? [
                        {
                            id: 'repaymentItem',
                            type: WIDGET.REPAYMENT,
                            padding: {
                                horizontal: -16,
                            },
                        },
                        {
                            id: 'repaymentSpace',
                            type: WIDGET.SPACE,
                            padding: {
                                horizontal: -16,
                            },
                        },
                    ]
                    : []),
                showInterestCalculator ? {
                    id: 'interestCalculatorCard',
                    type: WIDGET.INTEREST_CALCULATOR_ENTRY_CARD,
                } : {},
                !showBottomNavBar && (showTransactionHistory || showTrackLoanClosure || showAccountDetails || showManageLimit) ? {
                    id: "manageLoanDetails", type: WIDGET.MANAGE_LOAN_DETAILS
                } : {},
                showBenefitsSection ? {
                    id: 'promoCard',
                    type: WIDGET.PROMOCARD,
                    padding: {
                        horizontal: -16,
                        vertical: 0,
                    },
                } : {},
                (platform && platform === 'REDVISION') || !showBottomNavBar ? {} : {
                    id: 'cardNav',
                    type: WIDGET.CARD,
                    position: POSITION.STICKY_BOTTOM,
                    padding: {
                        left: 0,
                        right: 0,
                    },
                },
                isFromTDLPlatform() ? { id: "sdkProcessCompletedCard", type: WIDGET.SDK_PROCESS_COMPLETE_CARD } : {}
            ] : [
                {
                    id: 'pendingForeClosureHeader',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                },
                {
                    id: "pendingForeclosure",
                    type: WIDGET.PENDING_FORECLOSURE
                },
                {
                    id: 'cardNav',
                    type: WIDGET.CARD,
                    position: POSITION.STICKY_BOTTOM,
                    padding: {
                        left: 0,
                        right: 0,
                    },
                },
                isFromTDLPlatform() ? { id: "sdkProcessCompletedCard", type: WIDGET.SDK_PROCESS_COMPLETE_CARD } : {}
            ],
        },
        datastore: {
            interestCalculatorCard: {
                navAction: {
                    type: ACTION.NAV_TO_IC,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                },
            },
            loanExpiryFaqScreenStack: {
                width: StackWidth.MATCH_PARENT,
                bgColor: ColorTokens.White,
                padding: {
                    horizontal: SizeTypeTokens.XL,
                    top: SizeTypeTokens.XL
                },
                widgetItems: [
                    { id: "FaqHeaderTypograpy", type: WIDGET.TEXT },
                    { id: "FaqSpace1", type: WIDGET.SPACE },
                    { id: "loanExpiryFaq1", type: WIDGET.ACCORDION },
                    { id: "loanExpiryFaq2", type: WIDGET.ACCORDION },
                    { id: "loanExpiryFaq3", type: WIDGET.ACCORDION },
                    { id: "loanExpiryFaq4", type: WIDGET.ACCORDION },
                ],
            },
            spaceInterest: {
                size: SizeTypeTokens.MD,
            },
            FaqSpace1: {
                size: SizeTypeTokens.XL,
            },
            FaqHeaderTypograpy: {
                label: 'Frequently asked questions',
                typeDLS: TypographyTypeDLS.H4S,
                color: ColorTokens.Grey_Night,
            },
            interestRepaymentText: {
                label: statementLabel,
                typeDLS: TypographyTypeDLS.H4S,
                color: ColorTokens.Grey_Night,
            },
            loanExpiryFaq1: {
                id: '',
                faqDownArrowIcon: true,
                title: 'Why has my loan expired?',
                description: `The loan expires when the agreed-upon period in the loan agreement ends. To continue enjoying the benefits, ${isFromBajaj ? 'renew' : 'reopen'} your loan account in just 5 minutes. In case of any outstanding balance, kindly repay before the due date to avoid security sell-off.\n\nNote: Sell-off will be initiated to recover the outstanding balance and applied charges if repayment is not made before the due date. we will release the remaining securities within one month from the loan expiry date. For any query, feedback or support, call us or whatsapp us at ${callDeepLink}.`,
                icon: IconTokens.DownArrow,
                onPress: Function,
            },
            loanExpiryFaq2: {
                id: '',
                faqDownArrowIcon: true,
                title: 'What if I fail to repay outstanding balance?',
                description: `If you fail to repay the outstanding balance, including principal and charges, by the due date, the lender will initiate a portfolio sell-off process to recover the remaining amount.${isFromBajaj ? 'Following this, your remaining pledged portfolio will be unpledged within one month if you do not renew your loan.' : ''}`,
                icon: IconTokens.DownArrow,
                onPress: Function,
            },
            loanExpiryFaq3: {
                id: '',
                faqDownArrowIcon: true,
                title: 'How to reopen my loan account?',
                description: 'Reopen your loan swiftly in just 5 minutes and resume enjoying the benefits in three simple steps: complete KYC, set up the mandate, and sign agreement.',
                icon: IconTokens.DownArrow,
                onPress: Function,
            },
            loanExpiryFaq4: {
                id: '',
                faqDownArrowIcon: true,
                title: 'What will happen to my securities?',
                hideDivider: true,
                description: 'Your pledged securities will be automatically unpledged within 1 month from the loan expiry date if your remaining outstanding is ZERO.\n\nNote:\n1. Repay the outstanding amount to avoid securities sell-off.\n2. Contact support to unpledge your portfolio when the loan has expired.',
                icon: IconTokens.DownArrow,
                onPress: Function,
            },
            loanRenewalFlowCardBottomSpace0: {
                size: SizeTypeTokens.XL
            },
            withdrawalRejectionCard: {
                detailsAction: {
                    type: ACTION.WITHDRAWAL_REJECTION_TRANSACTION_HISTORY,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                },
                retryAction: {
                    type: ACTION.NAVIGATE_TO_WITHDRAWAL_SCREEN,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        interestReponse: interestReponse,
                        interestRepaymentType: interestRepaymentType,
                        shortfallDetails,
                        availableCreditAmount
                    }
                },
                withdrawalRejectedData: withdrawalRejectionResponse,
                availableCreditLimit: availableCreditAmount,
                title: 'Repayment failed',
                dataArray: []
            },
            headerCustom: {
                title: "",
                shouldShowShadow: false,
                showNeedHelp: true,
                isBackButton: true,
                leftIcon: {
                    id: 'bt_profileScreen_goBack',
                    name: IconTokens.Cross,
                    size: IconSizeTokens.XXL,
                    color: ColorTokens.Grey_Charcoal,
                },
                type: HeaderTypeTokens.HEADERCTA,
                action: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.DASHBOARD,
                },
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    payload: {},
                    routeId: ROUTE.DASHBOARD,
                },
                goBackAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.DASHBOARD,
                },
            },
            interestRepaymentCard: {
                bankAccount: "",
                viewDetailAction: {
                    type: ACTION.INTEREST_REPAYMENT_DETAILS,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        interestReponse: interestReponse,
                        type: interestRepaymentType
                    }
                },
                backAction: {
                    type: ACTION.CONTACT_US,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                },
                learnMoreAction: {
                    type: ACTION.LEARN_MORE_INTEREST,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        interestReponse: interestReponse,
                        type: interestRepaymentType,
                        isFromTata: !isFromBajaj
                    }
                },
                type: interestRepaymentType,
                interestRepaymentData: interestReponse,
                bankDetail: bankDetails,
                isFromTata: !isFromBajaj,
                lenderId: _user?.linkedApplications[0].lenderAccountId.toLowerCase()
            },
            loanRenewalFlowCard: {
                amount: renewalAmount ? renewalAmount : 0,
                loanExpiryDays: `${renewalDateDelta}`,
                show: true,
                creditLimitAmount: actualLoanAmount ? actualLoanAmount : 0,
                ctaAction: {
                    type: ACTION.RENEW_NOW,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        actualLoanAmount: actualLoanAmount,
                        loanExpiryDays: renewalDateDelta,
                    }
                },
                learnMoreAction: {
                    type: ACTION.LEARN_MORE,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                }
            },
            loanRenewalFlowExpiredCard: {
                loanExpiryDay: loanExpiryDay,
                lenderId: _user?.linkedApplications[0].lenderAccountId.toLowerCase(),
                isLoanExpired: await SharedPropsService.getIsLoanExpired(),
                dueDay: dueDate,
                creditLimitAmount: actualLoanAmount,
                outStandingAmount: loanExpiryScenario === LoanRenewalScenario.AFTER_30_DAYS
                    ? 0
                    : overDueAmount
                        ? overDueAmount
                        : 0,
                scenario: loanExpiryScenario,
                isRepaymentInProgress: inProgressTransaction,
                showInfoSection: showInfoSection,
                customerSupportAction: {
                    routeId: ROUTE.DASHBOARD,
                    type: ACTION.CONTACT_US,
                    payload: {}
                },
                renewNowAction: {
                    routeId: ROUTE.DASHBOARD,
                    type: ACTION.RENEW_NOW,
                    payload: {
                        isLoanExpired: true
                    }
                },
                repayAction: {
                    routeId: ROUTE.DASHBOARD,
                    type: ACTION.LOAN_EXPIRED_REPAYMENT,
                    payload: {}
                },
                reOpenLoanAccountAction: {
                    routeId: ROUTE.DASHBOARD,
                    type: ACTION.REOPEN_LOAN_ACCOUNT,
                    payload: {}
                },
                refundAction: {
                    routeId: ROUTE.DASHBOARD,
                    type: ACTION.REFUND_LOAN,
                    payload: {}
                },
                showCta: showCta,
                isPendingLoanRenewal,
            },
            card2: {
                body: {
                    widgetItems: isFirstJourney
                        ? [
                            { id: "space8", type: WIDGET.SPACE },
                            { id: 'widgetText', type: WIDGET.TEXT },
                            { id: 'widgetText2', type: WIDGET.TEXT },
                            isFromBajaj ?
                                { id: 'widgetText3', type: WIDGET.TEXT } : {},
                            { id: 'widgetText4', type: WIDGET.TEXT },
                            { id: "space8", type: WIDGET.SPACE },
                        ]
                        : [
                            { id: "space8", type: WIDGET.SPACE },
                            { id: 'widgetText', type: WIDGET.TEXT },
                            isFromBajaj ?
                                { id: 'widgetText3', type: WIDGET.TEXT } : {},
                            { id: 'widgetText4', type: WIDGET.TEXT },
                            { id: "space8", type: WIDGET.SPACE },
                        ],
                },
                bgColor: ColorTokens.Yellow_10,
            },
            pendingForeclosure: {
                color: ColorTokens.Grey_Charcoal,
                viewAction: {
                    type: ACTION.CONTACT_US,
                    routeId: ROUTE.DASHBOARD,
                },
                stepperData: pendingForeclosureStepperData,
                createdOnDate: pendingClosurePlacedDate,
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                }
            },
            pdCard: {
                color: ColorTokens.Grey_Charcoal,
                isList: true,
                actionList: pendingArray,
                viewAction: {
                    type: ACTION.STATUS,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        renewalRequestDetailsList: renewalRequestDetailsList,
                        value: fundNumber
                    },
                },
            },
            widgetText: {
                label: 'We’re processing your withdrawal request. Please note',
                color: ColorTokens.Grey_Night,
                fontWeight: 'bold',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XXS,
                lineHeight: 16
            },
            widgetText2: {
                label: `\u2022 ₹${processingFess} one-time processing fee will be deducted `,
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter,
            },
            widgetText3: {
                label: '\u2022 Transfer may take up to 6 banking hours',
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter,
            },
            widgetText4: {
                label: '\u2022 Requests posts 4PM may take up to 12PM of next day',
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XXS,
                fontWeight: '500',
                lineHeight: 16,
                fontFamily: FontFamilyTokens.Inter,
            },
            header: {
                bgColor: ColorTokens.White,
                shadow: ShadowTypeTokens.E2,
                padding: {
                    top: Platform.OS === "ios" ? SizeTypeTokens.XXXXXXL : SizeTypeTokens.LG,
                    left: SizeTypeTokens.XL,
                    right: SizeTypeTokens.XL,
                },
                width: StackWidth.MATCH_PARENT,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: 'titleContainer', type: WIDGET.STACK },
                    { id: 'headerRight', type: WIDGET.STACK },
                ],
            },
            backButton: {
                name: IconTokens.BackArrowIcon,
                size: IconSizeTokens.XXL
            },
            pendingForeClosureHeader: {
                bgColor: ColorTokens.White,
                shadow: ShadowTypeTokens.E2,
                padding: {
                    top: Platform.OS === "ios" ? SizeTypeTokens.XXXXXXL : SizeTypeTokens.LG,
                    left: SizeTypeTokens.XL,
                    right: SizeTypeTokens.XL,
                    bottom: Platform.OS === "ios" ? SizeTypeTokens.XXXXXXL : SizeTypeTokens.LG,
                },
                width: StackWidth.MATCH_PARENT,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: 'titleContainer', type: WIDGET.STACK },
                    { id: 'headerRight', type: WIDGET.STACK },
                ],
            },
            headerRight: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.flexEnd,
                padding: {
                    bottom: showMyAccountIcon ? SizeTypeTokens.NONE : SizeTypeTokens.MD
                },
                widgetItems: [
                    ...(showContactUs && showContactus(platform)
                        ? [{ id: 'contactUs', type: WIDGET.TAG }]
                        : []),
                    showContactus(platform) ? { id: 'contactUsSpace', type: WIDGET.SPACE } : {},
                    showMyAccountIcon ? { id: 'leadIcon', type: WIDGET.BUTTON } : {},
                ],
            },
            contactUs: {
                id: 'txt_dashboard_contactUs',
                icon: {
                    align: IconAlignmentTokens.left,
                    name: showBottomNavBar ? IconTokens.Whatsapp : IconTokens.CONTACT_ICON,
                    size: IconSizeTokens.XL,
                },
                label: 'NEED HELP?',
                labelColor: ColorTokens.Primary_100,
                type: TagTypeTokens.DEFAULT,
                bgColor: ColorTokens.Primary_05,
                action: {
                    type: ACTION.CONTACT_US,
                    routeId: ROUTE.DASHBOARD,
                    payload: {},
                },
            },
            contactUsSpace: { size: SizeTypeTokens.SM },
            titleContainer: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'title1', type: WIDGET.TEXT },
                    { id: 'title2', type: WIDGET.TEXT },
                ],
            },
            title1: {
                label: userName?.length <= 10 ? `Welcome, ` : 'Welcome!',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '400',
                lineHeight: 24,
            },
            title2: {
                label: `${userName?.length <= 10 ? userName : ''}`,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                lineHeight: 24,
            },
            leadIcon: {
                id: 'bt_dashboard_profile',
                label: '',
                type: ButtonTypeTokens.SmallGhost,
                width: ButtonWidthTypeToken.CONTENT,
                stack: {
                    type: StackType.row,
                    alignItems: StackAlignItems.flexStart,
                    justifyContent: StackJustifyContent.flexStart,
                },
                icon: {
                    name: IconTokens.Account,
                    align: IconAlignmentTokens.right,
                    size: IconSizeTokens.XXXXL,
                },
                action: {
                    type: ACTION.PROFILE,
                    payload: {},
                    routeId: ROUTE.DASHBOARD,
                },
            },
            cardItem: {
                width: StackWidth.MATCH_PARENT,
                // bgColor: ColorTokens.Primary_02,
                widgetItems: [
                    { id: 'amountItem', type: WIDGET.AMOUNTCARD },
                    { id: 'cardSpace', type: WIDGET.SPACE },
                    showNewDashboardCard ? {} : { id: 'continue', type: WIDGET.BUTTON },
                    { id: 'continueSpace', type: WIDGET.SPACE },
                    ...((repaymentAmount > 0 && !showNewDashboardCard)
                        ? [
                            {
                                id: 'repaymentCard',
                                type: WIDGET.CARD,
                                padding: {
                                    horizontal: 0,
                                    all: 0,
                                },
                            },
                            { id: 'repaymentSpace', type: WIDGET.SPACE },
                        ]
                        : []),
                ],
            },
            message: {
                label: 'Your verification is in progress. Meanwhile you can’t withdraw the amount ',
                labelColor: ColorTokens.Grey_Charcoal,
                bgColor: ColorTokens.System_Warning_BG,
            },
            message2: {
                label: `Your previous withdrawal request of Rs.${amountDisbursal} is in progress, meanwhile you cannot raise another request.`,
                labelColor: ColorTokens.Grey_Charcoal,
                bgColor: ColorTokens.System_Warning_BG,
            },
            amountItem: {
                id: 'txt_dashboard_availableCash',
                newWithdrawFlow: showNewDashboardCard,
                title: 'Available cash',
                subTitle: `${availableCreditAmount}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ','),
                subscriptTitle: showNewDashboardCard ? "" :
                    'out of ₹' +
                        `${actualLoanAmount}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ','),
                progressLabel: showNewDashboardCard ? "" :
                    `${Math.trunc((availableCreditAmount / actualLoanAmount) * 100)}` + '% of total limit available',
                chipText: '',
                type: AmountCardTypeTokens.wallet,
                progressFillPercentage: showNewDashboardCard ? "" : `${(Math.max(availableCreditAmount, 0) * 100) /
                    actualLoanAmount}%`,
                typeWithdrawButton: isDisbursalRequestAllowed && availableCreditAmount > 0
                    ? ButtonTypeTokens.LargeFilled
                    : ButtonTypeTokens.LargeOutline,
                repayMessage: 'Outstanding amount',
                repayAmount: `${repaymentAmount}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ','),
                repayAction: {
                    type: ACTION.REPAYMENT,
                    payload: {
                        repaymentAmount: `${repaymentAmount}`,
                    },
                    routeId: ROUTE.DASHBOARD,
                },
                withdrawAction: {
                    type: ACTION.DASHBOARD,
                    payload: {
                        value: availableCreditAmount,
                        widgetId: 'continue',
                    },
                    routeId: ROUTE.DASHBOARD,
                },
                disableRepayAndWihtdraw: (isPendingLoanRenewal && isLoanExpired)
            },
            shortfallCard: {
                shortfallAmount,
                showPendingUnpledge,
                daysLeft,
                lender: shortfallDetails?.lenderId,
                navigateToShotfallDetails: {
                    type: ACTION.SHORTFALL_DETAILS,
                    payload: { shortfallDetails, availableCreditAmount },
                    routeId: ROUTE.DASHBOARD,
                },
                navigateToShortfallInfoScreen: {
                    type: ACTION.NAVIGATE_TO_SHORTFALL_INFO_SCREEN,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                },
            },
            cardSpace: { size: SizeTypeTokens.XL },
            continue: {
                id: 'bt_dashboard_withdrawNow',
                label: 'Withdraw',
                type: isDisbursalRequestAllowed && availableCreditAmount > 0
                    ? ButtonTypeTokens.LargeFilled
                    : ButtonTypeTokens.LargeOutline,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.DASHBOARD,
                    payload: {
                        value: availableCreditAmount,
                        widgetId: 'continue',
                    },
                    routeId: ROUTE.DASHBOARD,
                },
            },
            continueSpace: { size: SizeTypeTokens.XXXL },
            repaymentItem: {
                id: 'txt_dashboard_outstandingAmount',
                title: 'Repayment',
                message: 'Outstanding amount',
                amount: `${repaymentAmount}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ','),
                btnText: 'Flexi pay',
                action: {
                    type: ACTION.REPAYMENT,
                    payload: {
                        repaymentAmount: `${repaymentAmount}`,
                    },
                    routeId: ROUTE.DASHBOARD,
                },
            },
            repaymentSpace: { size: SizeTypeTokens.XL },
            promoCard: {
                data: [
                    {
                        id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
                        title: 'Instant money transfer',
                        subTitle: 'Get money instantly when you need it',
                        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOuSURBVHgBlVVdiBtVFP7uzcxssm6SadaudjWS+AObrSIt9cm/rlWXotIHoaCgFMQXfVlfKtpWC32oCtLYUvAH7GMriIqwyrKW1rrUF6Gt7o+0uJvuuu1uaJppOplkfm/vhM1kEia72Q9C7rn3nO8799yTE4I1wCbHH3BC9Hd3bcAYimR25rAO0LUcTLAE/0q5HwnSmcrMrymsA6sKHBmZk7/8bmDrciFSWNlKaWr32N73pt8aGbmQqvuxy6dfs6dPz9kzv33VykGCiLP7rj4VouQQX2537XSyjJ1PX/POv/65F7PXJchRe/SD1/OMAS97GTvkUbL5uam6LbSSH/tofh8cHPKLKyWxyefFbWVcmnUw/ITyEvPtM8Ms21X1Eb6cCrzB0QPzJ/jGnlbR+/o07Hp+EavB0bQaGw1HYNns1a7HXvih6QbH9i98zHPYExSckA2sBdrd3TBERLz9Wub75x8CYQfbBd9/r4aOwF+DVTSF3i6/rf8znvEEKCXfrha3aWMVncDRdZ69KNOenmcFge5194SjBxa3MGY/ExggUiTCOsJddif8vP5h1G/iGMZyTYAxZxdpbVZuF9NRFB+Oo7eyiHXBceCUVZCu8PvW9Hg/DRG21X9uxiUsPHkPCgMyHIHgYqwfN51w5wKUgkZjIJLEl6E0dRjbVLtViMB4PA79lT44CakhyChOaoNYLwgjEzojb1BenoQjS6gM93GBGM+AIBZtdv7PknFOT3ZEbFoEZy9Gl8jkje2RzFBO0LdtmDQHow/6ncQQ0MPbWvV151g1jc3iDfTSSlvyhbyI78/KWCoK/+7I7q51BjUz0bkgZ1dA9E2IChNwSssEEusmxeifcRz/8W4sFwXeIyRXP6Pc+gltEO9ptv2l0qohXMtHcHXxLpwcTeKPvxu/ZErYWH0txP7HX6UkFDDIrQJCm1KxWRNTFxoPVTYtb807PPfpkcFTnti7Q0QlFj5EGwSVauJWv2e70/SW0ZhVhJBv/PHeT+zwFXYGK/O/FRZ/roLCnQ2GxBUFck71zhQ+HkqG6WX/WXYw7Y/1/tGkKt7k6eSCBNxSbVB1JCeWmshLPHM/OX/QodbYpiFxeIalEMIvfNdrFzdr6ZICcUZtCizpBpSV0nDiy5xo+JNsJreqQEPIPshb4Z1Q3tjYdf4mqNp4RNNhKFarqNq1Nlf4gP7CgpHNZrcoQVyBAi4+P15IikulHbynd9uMDFQsO62ZJie28jzsPI88ZzL9RDviOu4A5zhsmkEc0QAAAAAASUVORK5CYII=',
                    },
                    {
                        id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
                        title: 'No usage, no interest',
                        subTitle: 'Pay interest only on the borrowed amount',
                        image: 'data:image/png;base64,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',
                    },
                    {
                        id: '58694a0f-3da1-471f-bd96-145571e29d72',
                        title: 'Repay anytime',
                        subTitle: 'Pay as low as interest amount as EMI, repay principal any time',
                        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOuSURBVHgBlVVdiBtVFP7uzcxssm6SadaudjWS+AObrSIt9cm/rlWXotIHoaCgFMQXfVlfKtpWC32oCtLYUvAH7GMriIqwyrKW1rrUF6Gt7o+0uJvuuu1uaJppOplkfm/vhM1kEia72Q9C7rn3nO8799yTE4I1wCbHH3BC9Hd3bcAYimR25rAO0LUcTLAE/0q5HwnSmcrMrymsA6sKHBmZk7/8bmDrciFSWNlKaWr32N73pt8aGbmQqvuxy6dfs6dPz9kzv33VykGCiLP7rj4VouQQX2537XSyjJ1PX/POv/65F7PXJchRe/SD1/OMAS97GTvkUbL5uam6LbSSH/tofh8cHPKLKyWxyefFbWVcmnUw/ITyEvPtM8Ms21X1Eb6cCrzB0QPzJ/jGnlbR+/o07Hp+EavB0bQaGw1HYNns1a7HXvih6QbH9i98zHPYExSckA2sBdrd3TBERLz9Wub75x8CYQfbBd9/r4aOwF+DVTSF3i6/rf8znvEEKCXfrha3aWMVncDRdZ69KNOenmcFge5194SjBxa3MGY/ExggUiTCOsJddif8vP5h1G/iGMZyTYAxZxdpbVZuF9NRFB+Oo7eyiHXBceCUVZCu8PvW9Hg/DRG21X9uxiUsPHkPCgMyHIHgYqwfN51w5wKUgkZjIJLEl6E0dRjbVLtViMB4PA79lT44CakhyChOaoNYLwgjEzojb1BenoQjS6gM93GBGM+AIBZtdv7PknFOT3ZEbFoEZy9Gl8jkje2RzFBO0LdtmDQHow/6ncQQ0MPbWvV151g1jc3iDfTSSlvyhbyI78/KWCoK/+7I7q51BjUz0bkgZ1dA9E2IChNwSssEEusmxeifcRz/8W4sFwXeIyRXP6Pc+gltEO9ptv2l0qohXMtHcHXxLpwcTeKPvxu/ZErYWH0txP7HX6UkFDDIrQJCm1KxWRNTFxoPVTYtb807PPfpkcFTnti7Q0QlFj5EGwSVauJWv2e70/SW0ZhVhJBv/PHeT+zwFXYGK/O/FRZ/roLCnQ2GxBUFck71zhQ+HkqG6WX/WXYw7Y/1/tGkKt7k6eSCBNxSbVB1JCeWmshLPHM/OX/QodbYpiFxeIalEMIvfNdrFzdr6ZICcUZtCizpBpSV0nDiy5xo+JNsJreqQEPIPshb4Z1Q3tjYdf4mqNp4RNNhKFarqNq1Nlf4gP7CgpHNZrcoQVyBAi4+P15IikulHbynd9uMDFQsO62ZJie28jzsPI88ZzL9RDviOu4A5zhsmkEc0QAAAAAASUVORK5CYII=',
                    },
                ],
                heading: 'Benefits for you',
            },
            cardNav: {
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.MD,
                },
                shadow: ShadowTypeTokens.E6,
                bgColor: ColorTokens.White,
                body: {
                    widgetItems: [
                        {
                            id: 'bottomNav',
                            type: WIDGET.BOTTOMTAB,
                        },
                    ],
                },
            },
            bottomNav: {
                action: {
                    type: ACTION.TRANSACTION,
                    payload: {
                    // value: 'transaction',
                    },
                    routeId: ROUTE.DASHBOARD,
                },
                data: [
                    {
                        id: '1',
                        qaId: 'txt_dashboard_myAccount',
                        title: 'My Account',
                        status: BottomTabStateToken.SELECTED,
                        icon: {
                            name: IconTokens.Chart,
                            size: IconSizeTokens.XL,
                            align: IconAlignmentTokens.left,
                            color: ColorTokens.Primary_100,
                        },
                    },
                    {
                        id: '2',
                        qaId: 'txt_dashboard_transactions',
                        title: 'Transactions',
                        status: BottomTabStateToken.NOT_SELECTED,
                        icon: {
                            name: IconTokens.RuppeFile,
                            size: IconSizeTokens.XL,
                            align: IconAlignmentTokens.left,
                            color: ColorTokens.Grey_Charcoal
                        },
                    },
                    {
                        id: '3',
                        qaId: 'txt_dashboard_manageLimit',
                        title: 'Manage Limit',
                        status: BottomTabStateToken.NOT_SELECTED,
                        icon: {
                            name: IconTokens.ManageLimit,
                            size: IconSizeTokens.XL,
                            align: IconAlignmentTokens.left,
                            color: ColorTokens.Grey_Charcoal,
                        },
                    },
                ],
            },
            space8: {
                size: SizeTypeTokens.MD
            },
            spaceFaq: {
                size: SizeTypeTokens.XXXL
            },
            spaceMD: {
                size: SizeTypeTokens.MD
            },
            space16: {
                size: SizeTypeTokens.XL
            },
            manageLoanDetails: {
                height: 398,
                accountDetailsAction: {
                    type: ACTION.NAVIGATE_ACCOUNT_DETAILS,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        value: profileDetails
                    }
                },
                transactionDetailsAction: {
                    type: ACTION.NAVIGATE_TRANSACTION_DETAILS,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        value: profileDetails
                    }
                },
                manageLimitAction: {
                    type: ACTION.NAVIGATE_MANAGE_LIMIT,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        value: profileDetails
                    }
                },
                trackLoanStatusAction: {
                    type: ACTION.NAVIGATE_TRACK_LOAN_CLOSURE,
                    routeId: ROUTE.DASHBOARD,
                },
                showAccountDetails: showAccountDetails,
                showTransactionHistory: showTransactionHistory,
                showManageLimit: showManageLimit,
                showTrackLoanClosure: showTrackLoanClosure,
                showForeclosureTracking: showForeclosureTracking,
            },
            sdkProcessCompletedCard: {
                visible: shouldShowWithdrawalCard,
                onWithdrawClickAction: {
                    type: ACTION.ON_WITHDRAW_CLICK_ACTION,
                    routeId: ROUTE.DASHBOARD,
                    payload: {
                        availableCreditAmount: availableCreditAmount
                    }
                },
                onModalCloseAction: {
                    type: ACTION.CLOSE_SDK_PROCESS_COMPLETE_CARD,
                    routeId: ROUTE.DASHBOARD,
                    payload: {}
                },
                isCreditStatusActive: isCreditStatusActive,
                availableCreditLimit: availableCreditAmount
            },
        },
    };
};
export const dashboardMF = {
    onLoad: async ({ network, instrumentTrack, removeWidgets, navigateToBase }, { ...params }) => {
        await initializeFirebase();
        // const cacheManageLimitConfig = params?.cacheManageLimitConfig;
        const cacheManageLimitConfig = false;
        const userPaymentData = new Object();
        // const cacheCreditData = params?.cacheCreditData;
        const cacheCreditData = false;
        const cachePendingCreditRequestByCreditId = params?.cachePendingCreditRequestByCreditId;
        const cacheUserContext = params?.cacheUserContext;
        // ---------------- Need to hard reload the notification card -----------------//
        await removeWidgets(ROUTE.DASHBOARD, [
            { id: 'pdCard', type: WIDGET.PENDING_UNPLEDGE_VIEW },
            { id: 'loanRenewalFlowCard', type: WIDGET.LOAN_RENEWAL_DASHBOARD_CARD },
            { id: 'loanRenewalFlowCardBottomSpace0', type: WIDGET.SPACE },
            { id: 'card2', type: WIDGET.CARD },
            { id: 'message2', type: WIDGET.MESSAGE },
            { id: 'cardItem', type: WIDGET.STACK },
            { id: 'repaymentItem', type: WIDGET.REPAYMENT },
            { id: 'repaymentSpace', type: WIDGET.SPACE },
            { id: 'promoCard', type: WIDGET.PROMOCARD },
            { id: 'cardNav', type: WIDGET.CARD },
            { id: 'header', type: WIDGET.STACK },
            { id: 'pendingForeclosure', type: WIDGET.PENDING_FORECLOSURE },
            { id: 'loanRenewalFlowExpiredCard', type: WIDGET.LOAN_RENEWAL_EXPIRED_DASHBOARD_CARD },
            { id: 'loanExpiryFaqScreenStack', type: WIDGET.STACK },
            { id: 'interestRepaymentCard', type: WIDGET.INTEREST_REPAYMENT_CARD },
            { id: 'interestRepaymentText', type: WIDGET.TEXT },
            { id: 'shortfallCard', type: WIDGET.SHORTFALL_CARD },
            { id: 'interestCalculatorCard', type: WIDGET.INTEREST_CALCULATOR_ENTRY_CARD },
            { id: 'withdrawalRejectionCard', type: WIDGET.WITHDRAWAL_FAILED_CARD }
        ]);
        // --------------------------------------------------------------------------- //
        await sharedPropsService.setIsRepaymentAfterExpiry(false);
        // let userContextResponse = await network.post(
        //     api.userContext,
        //     {},
        //     {headers: await getAppHeader()},
        // )
        const userContextResponse = await getUserContext(network, {
            overrideCache: cacheUserContext ? false : true
        });
        const _user = userContextResponse;
        const _creditId = _user?.linkedCredits[0]?.creditId;
        if (_creditId === null || _creditId === undefined) {
            await navigateToBase(ROUTE.BORROWER_LANDING_SCREEN);
            return;
        }
        let response = await network.get(
        // `${api.getCredit}/${userContextResponse.data.linkedCredits[0].creditId}`,
        `${api.getCredit}/${_creditId}`, {
            headers: await getAppHeader(),
        });
        await SharedPropsService.setCreditData(response?.data);
        response = response?.data;
        let showInterestRepayment = false;
        let interestResponse = await network.get(`${api.interestDetails}${_creditId}`, {
            headers: await getAppHeader(),
        }, null, {
            disableDefault: true
        });
        let isInterestRepaymentAllowed = await SharedPropsService.getFirebaseConfig().show_interest_repayment;
        let show_interest_calculator_feature = await showInterestCalculatorFlag();
        let statementLabel;
        //@ts-ignore
        if (isInterestRepaymentAllowed === true || isInterestRepaymentAllowed === "true") {
            if (interestResponse.status === 200) {
                // console.log("DSR interestResponse", interestResponse);
                statementLabel = `${interestResponse?.data?.month}'${interestResponse?.data?.year?.slice(2)} statement has been generated`;
                showInterestRepayment = true;
                userPaymentData.interestMonth = interestResponse?.data?.month;
                userPaymentData.interestYear = interestResponse?.data?.year;
                userPaymentData.isHavingInterestDue = true;
                userPaymentData.interestDue = interestResponse?.data?.outstandingInterest;
                userPaymentData.interestStatus = interestResponse?.data?.interestStatus;
                userPaymentData.isMandateSetup = interestResponse?.data?.isMandateSetup;
                userPaymentData.autoPayDate = interestResponse?.data?.autoPayDate;
            }
            else {
                showInterestRepayment = false;
                userPaymentData.interestMonth = '';
                userPaymentData.interestYear = '';
                userPaymentData.isHavingInterestDue = false;
                userPaymentData.interestDue = 0;
                userPaymentData.interestStatus = '';
                userPaymentData.isMandateSetup = false;
                userPaymentData.autoPayDate = '';
            }
        }
        await SharedPropsService.setUser(_user);
        // await SharedPropsService.setUser(userContextResponse.data)
        const lenderId = _user?.linkedCredits[0]?.lendingPartnerId;
        const url = Platform.OS === 'web' ? window.location.href : '';
        const paramsFromURL = Platform.OS === 'web' ? getParameters(url) : {};
        const isPgCallback = paramsFromURL?.uid || '';
        const platformCode = params?.platform || '';
        if (isPgCallback.length > 0 && Platform.OS === 'web') {
            window.location.replace(window.location.origin);
        }
        let showHeaderBackButton = params.platform === "TATADIGITAL" /* AppPlatform.TDL */;
        let showNewDashboardCard = false;
        showNewDashboardCard = await showNewDashboardWithdrawCard();
        let showNewWithdrawFlow = false;
        showNewWithdrawFlow = await SHOW_NEW_WITHDRAW_FLOW();
        let showShortfallDetails = false;
        showShortfallDetails = await showShortFallCard();
        const isShortfallDue = _user?.linkedCredits[0]?.isShortfallDue;
        let shortfallDetails;
        if (isShortfallDue) {
            const response = await network.get(
            // `${api.getShortfallDetails}/${userContextResponse.data.linkedCredits[0].creditId}`,
            `${api.getShortfallDetails}/${_creditId}`, {
                headers: await getAppHeader(),
                handleFromMF: true,
            });
            shortfallDetails = response?.data;
            userPaymentData.isHavingShortfall = true;
            userPaymentData.shortfallDue = shortfallDetails?.shortfallAmount;
            userPaymentData.recomendedShortfallAmount = shortfallDetails?.recommendedAmount;
        }
        else {
            userPaymentData.isHavingShortfall = false;
            userPaymentData.shortfallDue = 0;
        }
        const shortfallAmount = shortfallDetails?.shortfallAmount;
        const daysLeft = shortfallDetails?.daysLeft;
        const userName = _user?.user.fullName;
        const parts = userName?.split(" ");
        const firstName = parts[0];
        const formattedName = firstName?.toLowerCase()?.replace(/\b\w/g, (char) => char.toUpperCase());
        // response = response.data
        await sharedPropsService.setCreditData(response);
        // const pendingResponse = await network.get(
        //     // `${api.getPendingStatus}${userContextResponse?.data?.linkedCredits[0]?.creditId}`,
        //     `${api.getPendingStatus}${_creditId}`,
        //     {
        //         headers: await getAppHeader(),
        //     },
        // )
        let pendingResponse = await getPendingCreditRequestByCreditId(network, {
            overrideCache: true
        });
        pendingResponse.data = pendingResponse;
        if (pendingResponse?.data?.revocationRequestDetailsList?.length > 0) {
            await SharedPropsService.setUnpledgeRequest(true);
        }
        else {
            await SharedPropsService.setUnpledgeRequest(false);
        }
        let inProgressTransaction = false;
        if ((pendingResponse?.data?.collectionDetailsList &&
            pendingResponse?.data?.collectionDetailsList.length > 0) || (pendingResponse?.data?.disbursalDetailsList &&
            pendingResponse?.data?.disbursalDetailsList.length > 0)) {
            inProgressTransaction = true;
        }
        // ---- REMOVE THIS ----/
        //     inProgressTransaction = false;
        // ---- REMOVE THIS ----/
        const pendingDisbusalResponse = await network.get(
        // `${api.getPendingDisbursal}${userContextResponse?.data?.linkedCredits[0]?.creditId}`,
        `${api.getPendingDisbursal}${_creditId}`, {
            headers: await getAppHeader(),
        });
        const pendingArray = [];
        let isPendingLoanRenewal = false;
        if (await LOAN_RENEWAL_FLOW_SHOW()) {
            if (pendingResponse?.data?.renewalRequestDetailsList.length > 0) {
                isPendingLoanRenewal = true;
                pendingArray.push({
                    title: "Loan renewal in progress",
                    subTitle: "We’re processing your request. Track status",
                    type: requestType.RENEWAL_REQUEST
                });
            }
        }
        const transactionStatus = [];
        const collectionDetailsList = pendingResponse?.data?.collectionDetailsList;
        const disbursalDetailsList = pendingResponse?.data?.disbursalDetailsList;
        if (disbursalDetailsList?.length > 0) {
            transactionStatus.push({
                amount: disbursalDetailsList[0]?.amount,
                date: disbursalDetailsList[0]?.createdOn,
                type: "Withdraw"
            });
        }
        for (let list = 0; list < collectionDetailsList?.length; list++) {
            if (collectionDetailsList[list].collectionType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT) {
                transactionStatus.push({
                    amount: collectionDetailsList[list]?.actualAmountCollected,
                    date: collectionDetailsList[list]?.paymentDate,
                    type: REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT
                });
            }
            if (collectionDetailsList[list].collectionType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION) {
                transactionStatus.push({
                    amount: collectionDetailsList[list]?.actualAmountCollected,
                    date: collectionDetailsList[list]?.paymentDate,
                    type: REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION
                });
            }
            if (collectionDetailsList[list].collectionType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT) {
                transactionStatus.push({
                    amount: collectionDetailsList[list]?.actualAmountCollected,
                    date: collectionDetailsList[list]?.paymentDate,
                    type: REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION
                });
            }
            if (collectionDetailsList[list].collectionType === REPAYMENT_COLLECTION_TYPE.LOAN_EXPIRED_DUE_REPAYMENT) {
                transactionStatus.push({
                    amount: collectionDetailsList[list]?.actualAmountCollected,
                    date: collectionDetailsList[list]?.paymentDate,
                    type: REPAYMENT_COLLECTION_TYPE.LOAN_EXPIRED_DUE_REPAYMENT
                });
            }
        }
        const sortedDetailsList = transactionStatus.sort((a, b) => b.date - a.date);
        if (inProgressTransaction) {
            let descriptionText = "View details";
            if (sortedDetailsList.length === 2)
                descriptionText = `+1 more transactions. View details`;
            else if (sortedDetailsList.length > 2)
                descriptionText = `+${sortedDetailsList.length - 1} more transactions. View details`;
            if (sortedDetailsList?.length > 0) {
                if (sortedDetailsList[0].type === 'Withdraw') {
                    pendingArray.push({
                        title: `₹${addCommasToNumber(sortedDetailsList[0].amount)} processing for withdrawal`,
                        subTitle: descriptionText,
                        type: "TRANSACTION_STATUS"
                    });
                }
                else {
                    pendingArray.push({
                        title: `₹${addCommasToNumber(sortedDetailsList[0].amount)} processing for repayment`,
                        subTitle: descriptionText,
                        type: "TRANSACTION_STATUS"
                    });
                }
            }
        }
        const showLeinRemovalTracking = showLeinRemovalTrackingFlow();
        if (!showLeinRemovalTracking) {
            if (pendingResponse?.data?.enhanceLimitRequestDetailsList.length > 0) {
                pendingArray.push({
                    title: "Request for additional credit limit",
                    subTitle: "We're processing your request. Track status",
                    type: "ENHANCE"
                });
            }
            if (pendingResponse?.data?.revocationRequestDetailsList.length > 0) {
                pendingArray.push({
                    title: "Unpledge request in progress",
                    subTitle: "This may take up to 3-4 business days",
                    type: "REVOCATION"
                });
            }
        }
        const accountId = _user?.linkedApplications[0].accountId;
        const getUserPendingRequestList = await network.get(`${api.getPendingDetailsRequest}${accountId}`, {
            headers: await getAppHeader(),
        });
        if (getUserPendingRequestList?.data?.length > 0) {
            await SharedPropsService.setUserUpdateValue(getUserPendingRequestList?.data[0]?.updatedValue);
            if (getUserPendingRequestList?.data[0]?.requestType === UPDATE_REQUEST_TYPE.PHONE_NUMBER) {
                if (getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.REQUESTED) {
                    await SharedPropsService.setIsUserUpdateDetailsInProgress(true);
                    await SharedPropsService.setUserUpdateType(UPDATE_REQUEST_TYPE.PHONE_NUMBER);
                    pendingArray.push({
                        title: "Mobile number update in progress",
                        subTitle: "Expected completion in 1-3 business days",
                        type: "PHONE_NUMBER"
                    });
                }
                else if (getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.REJECTED || getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.FAILURE) {
                    await SharedPropsService.setIsUserUpdateDetailsInProgress(false);
                    pendingArray.push({
                        title: "Mobile number update request failed",
                        subTitle: "",
                        type: "PHONE_NUMBER"
                    });
                }
            }
            else {
                if (getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.REQUESTED) {
                    await SharedPropsService.setIsUserUpdateDetailsInProgress(true);
                    await SharedPropsService.setUserUpdateType(UPDATE_REQUEST_TYPE.EMAIL);
                    pendingArray.push({
                        title: "Email ID update in progress",
                        subTitle: "Expected completion in 1-3 business days",
                        type: "EMAIL"
                    });
                }
                else if (getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.REJECTED || getUserPendingRequestList?.data[0]?.status === UPDATE_STATUS_TYPE.FAILURE) {
                    await SharedPropsService.setIsUserUpdateDetailsInProgress(false);
                    pendingArray.push({
                        title: "Email ID update request failed",
                        subTitle: "",
                        type: "EMAIL"
                    });
                }
            }
        }
        else {
            await SharedPropsService.setIsUserUpdateDetailsInProgress(false);
        }
        const showPendingUnpledge = pendingArray.length > 0;
        const availableCreditAmount = Math.trunc(_.get(response, 'availableCreditAmount', 0));
        const actualLoanAmount = _.get(response, 'actualLoanAmount', 0);
        const tenureInDays = _.get(response, 'tenureInDays', 0);
        const repaymentAmount = _.get(response, 'principalOutStandingAmount', 0);
        userPaymentData.outstandingAmount = repaymentAmount;
        const processingFees = _.get(response, 'processingCharges', 0);
        const showContactUs = shouldShowVoltContactUs(await SharedPropsService.getURL());
        // userContextResponse.data.linkedCredits[0] = response
        _user.linkedCredits[0] = response;
        // const userCreditId = userContextResponse?.data?.linkedCredits[0]?.creditId
        const userCreditId = _user.linkedCredits[0]?.creditId;
        // const isPendingForeclosure = userContextResponse.data.linkedCredits[0].creditStatus === "PENDING_CLOSURE"
        const isPendingForeclosure = _user.linkedCredits[0].creditStatus === "PENDING_CLOSURE";
        let pendingClosurePlacedDate = '';
        if (isPendingForeclosure) {
            const getForeclosureInProgressResponse = await network.get(`${api.getForeclosureInProgress}${userCreditId}`, {
                headers: await getAppHeader(),
            });
            const pendingForeclosureCreatedOn = getForeclosureInProgressResponse?.data?.createdOn;
            const pendingForeclosureDate = getDateMonthYearFromEpochInIST(pendingForeclosureCreatedOn)?.slice(0, -6);
            pendingClosurePlacedDate = `${getISTTime(pendingForeclosureCreatedOn)}, ${pendingForeclosureDate}`;
        }
        await SharedPropsService.setUser(_user);
        // await SharedPropsService.setUser(userContextResponse.data)
        let isPendingDisbursalApproval = false;
        let isPendingDisbursalStatement = false;
        const amountDisbursal = 0;
        await SharedPropsService.setCreditStatus(response.creditStatus);
        let isDisbursalRequestAllowed = true;
        /*made it false to check */
        // isDisbursalRequestAllowed = false;
        const creditId = response.creditId;
        const isFirstJourney = pendingDisbusalResponse?.data?.isFirstDisbursal;
        isPendingDisbursalStatement = false;
        if (pendingDisbusalResponse?.data?.isPendingDisbursal) {
            isPendingDisbursalApproval = true;
            isDisbursalRequestAllowed = false;
        }
        const amountPercentage = Math.round((availableCreditAmount * 100) / actualLoanAmount);
        instrumentTrack('MY_ACCOUNT_PAGE_VIEWED', {
            loan_active: 'YES',
            lender_name: 'BAJAJ',
            available_credit_amount: availableCreditAmount,
            principal_outstanding_amount: repaymentAmount,
            total_credit_amount: actualLoanAmount,
            lender_credit_id: creditId
        });
        // const isFromBajaj = userContextResponse.data.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ
        const isFromBajaj = _user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ;
        const currentDate = new Date();
        let softBreachDate = isFromBajaj ? 6 : 2;
        let hardBreachDate = isFromBajaj ? 15 : 15;
        let sellOffDate = isFromBajaj ? 15 : 20;
        userPaymentData.softBreachDate = softBreachDate;
        userPaymentData.hardBreachDate = hardBreachDate;
        // const currentDayOfMonthFirebase = await SharedPropsService.getFirebaseConfig().test_current_date_sagar
        const currentDayOfMonth = currentDate.getDate();
        //  const currentDayOfMonth  = 22
        //     let currentDayOfMonthFirebase = await SharedPropsService.getFirebaseConfig().test_current_date
        // const currentDayOfMonth = parseInt(currentDayOfMonthFirebase)
        // Extract the day of the month from the current date
        // const currentDayOfMonth = currentDate.getDate();
        let interesRepaymentState;
        if (lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
            switch (interestResponse?.data?.interestStatus) {
                case INTEREST_REPAYMENT_STATUS.AWAITING_MANDATE_STATUS:
                    interesRepaymentState = InterestBounceType.DATE_BREACHED;
                    break;
                case INTEREST_REPAYMENT_STATUS.DUE:
                    interesRepaymentState = InterestBounceType.NORMAL;
                    break;
                case INTEREST_REPAYMENT_STATUS.OVERDUE:
                    interesRepaymentState = InterestBounceType.BOUNCED;
                    statementLabel = "Your account is overdue! ";
                    break;
            }
            if (!(interestResponse?.data?.isMandateSetup) && interesRepaymentState !== InterestBounceType.NORMAL) {
                statementLabel = "Your account is overdue! ";
            }
        }
        else {
            if (currentDayOfMonth <= softBreachDate) {
                interesRepaymentState = InterestBounceType.NORMAL;
            }
            else if (interestResponse?.data?.interestStatus === "AWAITING_MANDATE_STATUS" || !interestResponse?.data?.isMandateSetup && currentDayOfMonth > softBreachDate && currentDayOfMonth < hardBreachDate) {
                interesRepaymentState = InterestBounceType.DATE_BREACHED;
            }
            else if (currentDayOfMonth >= hardBreachDate) {
                interesRepaymentState = InterestBounceType.HARD_DATE_BREACHED;
                statementLabel = "Your account is overdue!  ";
                userPaymentData.interestState = InterestBounceType.HARD_DATE_BREACHED;
            }
            if (interestResponse?.data?.interestStatus === "OVERDUE" && currentDayOfMonth < hardBreachDate && interestResponse?.data?.isMandateSetup) {
                interesRepaymentState = InterestBounceType.BOUNCED;
                statementLabel = "Your account is overdue! ";
            }
            if (!(interestResponse?.data?.isMandateSetup) && interesRepaymentState !== InterestBounceType.NORMAL) {
                statementLabel = "Your account is overdue! ";
            }
        }
        // const userProfileResponse = await network
        //     .get(
        //         // `${api.userProfile}${userContextResponse.data.linkedBorrowerAccounts[0].accountId}`,
        //         `${api.userProfile}${_user.linkedBorrowerAccounts[0].accountId}`,
        //         {headers: await getAppHeader()},
        //     )
        const userProfileResponse = await getBorrowerProfile(network);
        // let bankDetails = userProfileResponse?.data?.bankDetails;
        let bankDetails = userProfileResponse?.bankDetails;
        userPaymentData.bankCode = bankDetails?.bankCode;
        userPaymentData.accountNumber = bankDetails?.accountNumber;
        // if(userProfileResponse?.status === 200) {
        //     await sharedPropsService.setBorrowerUserProfile(userProfileResponse?.data);
        // }
        const profileDetails = userProfileResponse;
        const platform = await sharedPropsService.getAppPlatform();
        // --------- LOAN RENEWAL FLOW CODE ------------ //
        let renewalDate;
        let renewalDateDelta;
        let RENEWAL_DATE_DELTA_FIREBASE;
        let renewalAmount;
        let showRenewalFlow = false;
        let isLoanContractExpired = false;
        let overDueAmount = 0;
        let dueDate;
        let loanExpiryDay;
        let loanExpiryScenario = LoanRenewalScenario.FIRST_7_DAYS;
        // ------- We will us this for the admin action --------- //
        const forceAllowPayment = await LOAN_RENEWAL_ALLOW_ADMIN();
        // ------------------------------------------------------ //
        if (await LOAN_RENEWAL_FLOW_SHOW()) {
            //check if pending loan renewal already exist
            await SharedPropsService.setIsLoanExpired(false);
            renewalDate = response?.renewalDate;
            renewalDateDelta = await getDaysDelta(renewalDate);
            const config = await SharedPropsService.getFirebaseConfig();
            const loan_renewal_repayment_date_TATA = config?.loan_renewal_repayment_date_TATA;
            const loan_renewal_repayment_date_BAJAJ = config?.loan_renewal_repayment_date_BAJAJ;
            const loan_renewal_test_flag = config?.loan_renewal_test_flag;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            const currentMoment = (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') ? await mockCurrentDate() : moment().startOf('day').unix() * 1000;
            const sevenDaysInMs = 6 * 24 * 60 * 60 * 1000;
            const lastRepaymentDateEpoch = renewalDate + sevenDaysInMs;
            const lastRepaymentDate = returnDateInString(lastRepaymentDateEpoch);
            const dueDay = lenderId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
                ? loan_renewal_repayment_date_BAJAJ
                : loan_renewal_repayment_date_TATA;
            dueDate = lenderId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() ? `${dueDay}${addSuffix(dueDay)} ${moment().format('MMM')}, ${moment().format('YYYY')}` : lastRepaymentDate;
            // ------------- loan not expired ----------- //
            if (pendingResponse?.data?.renewalRequestDetailsList.length === 0) {
                RENEWAL_DATE_DELTA_FIREBASE = await SharedPropsService.getFirebaseConfig()?.loan_renewal_date;
                if (currentMoment <= renewalDate &&
                    renewalDateDelta <= RENEWAL_DATE_DELTA_FIREBASE &&
                    renewalDateDelta != -1) {
                    isLoanContractExpired = false;
                    showRenewalFlow = true;
                    renewalAmount = response?.principalOutStandingAmount;
                }
            }
            // -------------------------------------------- //
            // ---------------- loan expired -------------- //
            if (currentMoment >= renewalDate ||
                renewalDateDelta === -1) {
                await sharedPropsService.setIsLoanExpired(true);
                const getForeClosureData = await getForeClosureDetails(network, {
                    overrideCache: true
                });
                if (getForeClosureData) {
                    overDueAmount = getForeClosureData?.netPayable;
                    if (await SharedPropsService.getIsLoanExpired() && lenderId.toLowerCase() === LENDER_ID.TATA && overDueAmount === 0) {
                        loanExpiryScenario = LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING;
                    }
                    else if (renewalDateDelta <= 7 && overDueAmount < 0 && lenderId.toLowerCase() === LENDER_ID.TATA) {
                        loanExpiryScenario = LoanRenewalScenario.OUTSTANDING_EXPIRED;
                    }
                    else if (renewalDateDelta <= 7) {
                        loanExpiryScenario = LoanRenewalScenario.FIRST_7_DAYS;
                    }
                    else if (typeof currentMoment === 'number' &&
                        currentMoment <= addMonthsToEpochTimetamp(renewalDate, 1) &&
                        moment(currentMoment).isSame(addMonthsToEpochTimetamp(renewalDate, 1)) === false) {
                        loanExpiryScenario = LoanRenewalScenario.FROM_7_TO_30_DAYS;
                    }
                    else {
                        loanExpiryScenario = LoanRenewalScenario.AFTER_30_DAYS;
                    }
                    isLoanContractExpired = true;
                    showRenewalFlow = false;
                    loanExpiryDay = renewalDate
                        ? (lenderId.toLowerCase() === LENDER_ID.TATA ? getDateMonthYearFromEpochIst(renewalDate) : getDateMonthYearFromEpoch(renewalDate))
                        : 'NA';
                }
                // --------------------------------------- //
            }
            await sharedPropsService.setLoanRenewalData({
                loanExpiryDays: renewalDateDelta,
                actualLoanAmount: actualLoanAmount,
                tenureInDays: tenureInDays,
            });
        }
        let dummyJson = {
            "totalAmount": 750.00,
            "outstandingInterest": 750.00,
            "month": "Feb",
            "year": "2024",
            "autoPayDate": 1709749800000,
            "isMandateSetup": true,
            "repaymentAllowed": true,
            "interestStatus": "DUE",
            "outStandingCharges": 0
        };
        const _url = await SharedPropsService.getURL();
        const callDeepLink = await getContactNumberForCall(_url);
        const pendingForeclosureStepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Loan closure request accepted",
                "verticalDescription": `Placed by you at ${pendingClosurePlacedDate}`,
                "order": 0,
                "highLightText": false
            },
            {
                "status": "IN_PROGRESS",
                "verticalDisplayName": "Loan closure processing",
                "verticalDescription": Platform.OS !== "web" ? "It may take up to 1-2 working days to process\nyour request. No additional interest will be\ncharged." : "It may take up to 1-2 working days to process your request. No additional interest will be charged.",
                "order": 1,
                "highLightText": true
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "RTA(s) will be notified to remove pledge",
                "verticalDescription": Platform.OS !== "web" ?
                    "SEBI authorised RTAs (CAMS and KFintech)\nhave been notified to remove pledge from\nyour portfolio. It may take them 4-5 business\ndays."
                    : "SEBI authorised RTAs (CAMS and KFintech) have been notified to remove pledge from your portfolio. It may take them 4-5 business days.",
                "order": 2,
                "highLightText": false
            },
        ];
        const showBottomNavBar = await SharedPropsService.getShowVoltBottomBar();
        const showAccountDetails = await SharedPropsService.getShowAccountDetails();
        const showTransactionHistory = await SharedPropsService.getShowTransactionHistory();
        const showManageLimit = await SharedPropsService.getShowManageLimit();
        const showTrackLoanClosure = await SharedPropsService.getShowLoanClosure();
        const showBenefitsSection = await SharedPropsService.getShowDashboardBenefitsForYou();
        const showMyAccountIcon = await SharedPropsService.getShowMyAccountIcon();
        const user = await SharedPropsService.getUser();
        // const manageLimitConfig = await network
        //     .get(
        //         `${api.manageLimitConfig}${user.linkedCredits[0].creditId}`,{ headers: await getAppHeader() })
        const manageLimitConfig = await getManageLimitConfig(network, { overrideCache: cacheManageLimitConfig ? false : true });
        // const allowForeclosure = manageLimitConfig?.data?.loanForeClosureAllowed
        const allowForeclosure = manageLimitConfig?.loanForeClosureAllowed;
        // --------------------------------------------- //
        // -------------------------------- //
        let showInterestCalculator = true;
        // const platformCongig = await network.get(
        //     api.platformDetailsApi,
        //     {
        //         headers: await getAppHeader()
        //     }
        // )
        // if(platformCongig?.status === 200) {
        //     showInterestCalculator = platformCongig?.data?.platformSDKConfig?.showInterestCalculator;
        //     await SharedPropsService.setShowInterestCalculator(showInterestCalculator);
        // }
        showInterestCalculator = _user?.linkedPlatformAccounts[0]?.platformSDKConfig?.showInterestCalculator;
        if (
        // @ts-ignore
        show_interest_calculator_feature === 'false' ||
            show_interest_calculator_feature === false) {
            showInterestCalculator = false;
        }
        // -------------------------------- //
        let rejectionDataArray = [];
        let getWithdrawalFailureRequestResponse = await network.get(`${api.getWithdrawalFailureRequest}${_creditId}?creditRequestTypes=COLLECTION_REQUEST&&creditRequestTypes=DISBURSAL_REQUEST`, {
            headers: await getAppHeader(),
        });
        const showWithdrawalRejectionFlagFromFirebase = await showWithdrawRejectedCard(_user);
        const showRepaymentRejectionFlagFromFirebase = await showRepaymentRejectedCard(_user);
        if (getWithdrawalFailureRequestResponse?.status === 200) {
            if (getWithdrawalFailureRequestResponse?.data?.collectionDetailsList.length > 0 && showRepaymentRejectionFlagFromFirebase) {
                const repaymentRejection = getWithdrawalFailureRequestResponse?.data?.collectionDetailsList[0];
                rejectionDataArray.push({
                    amount: repaymentRejection?.actualAmountCollected,
                    dateEpoch: repaymentRejection?.createdOn,
                    title: 'Repayment failed',
                    type: 'REPAYMENT_FAILED',
                    data: repaymentRejection
                });
            }
            if (getWithdrawalFailureRequestResponse?.data?.disbursalDetailsList.length > 0 && showWithdrawalRejectionFlagFromFirebase) {
                const withdrawalRejection = getWithdrawalFailureRequestResponse?.data?.disbursalDetailsList[0];
                rejectionDataArray.push({
                    amount: withdrawalRejection?.amount,
                    dateEpoch: withdrawalRejection?.createdOn,
                    title: 'Withdrawal failed',
                    type: 'WITHDRAWAL_FAILED',
                    data: withdrawalRejection
                });
            }
        }
        const hasDisbursalDetails = getWithdrawalFailureRequestResponse?.data?.disbursalDetailsList?.length > 0;
        const hasRepaymentDetails = getWithdrawalFailureRequestResponse?.data?.collectionDetailsList?.length > 0;
        const showWithdrawalRejectedCarousal = ((showWithdrawalRejectionFlagFromFirebase && hasDisbursalDetails) ||
            (showRepaymentRejectionFlagFromFirebase && hasRepaymentDetails));
        const isFromTDL = paramsFromURL?.platform === "TATADIGITAL" /* AppPlatform.TDL */;
        const isCreditStatusActive = user?.linkedCredits[0]?.creditStatus === "ACTIVE";
        const shouldShowWithdrawalCard = isFromTDL && await AsyncStorage.getItem("showProcessCompletedCard") !== 'true';
        let showCta;
        let showInfoSection;
        if (pendingResponse?.data?.renewalRequestDetailsList?.length > 0) {
            await SharedPropsService.setIsInProgressLoanRenewal(true);
        }
        else
            await SharedPropsService.setIsInProgressLoanRenewal(false);
        if (pendingResponse?.data?.renewalRequestDetailsList?.length > 0) {
            showCta = false;
        }
        else if (forceAllowPayment &&
            (forceAllowPayment === true || forceAllowPayment === 'true')) {
            showCta = true;
        }
        else if (loanExpiryScenario === LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING) {
            showCta = false;
        }
        else if (loanExpiryScenario === LoanRenewalScenario.FROM_7_TO_30_DAYS &&
            overDueAmount === 0) {
            showCta = true;
        }
        else {
            showCta = loanExpiryScenario !== LoanRenewalScenario.FROM_7_TO_30_DAYS;
        }
        if (pendingResponse?.data?.renewalRequestDetailsList?.length > 0 || (inProgressTransaction === true && lenderId.toLowerCase() !== LENDER_ID.TATA) ||
            //@ts-ignore
            forceAllowPayment === true || forceAllowPayment === "true") {
            showInfoSection = false;
        }
        else if (overDueAmount > 0 ||
            loanExpiryScenario === LoanRenewalScenario.OUTSTANDING_EXPIRED ||
            loanExpiryScenario === LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING) {
            showInfoSection = true;
        }
        else {
            showInfoSection = false;
        }
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        await SharedPropsService.setPaymentData(userPaymentData);
        return Promise.resolve(await template(availableCreditAmount, actualLoanAmount, repaymentAmount, isPendingDisbursalApproval, amountPercentage, isPendingDisbursalStatement, isDisbursalRequestAllowed, amountDisbursal, processingFees, isFirstJourney, showContactUs, platform, _user, showPendingUnpledge, pendingResponse?.data?.revocationRequestDetailsList, isPendingForeclosure, isFromBajaj, pendingArray, formattedName, showRenewalFlow, renewalDateDelta, renewalAmount, pendingResponse?.data?.renewalRequestDetailsList, showNewDashboardCard, isLoanContractExpired, overDueAmount, loanExpiryDay, loanExpiryScenario, dueDate, inProgressTransaction, isPendingLoanRenewal, forceAllowPayment, callDeepLink, interesRepaymentState, interestResponse.data, showInterestRepayment, showNewWithdrawFlow, statementLabel, bankDetails, pendingForeclosureStepperData, pendingClosurePlacedDate, isShortfallDue, showShortfallDetails, shortfallAmount, daysLeft, shortfallDetails, showBottomNavBar, profileDetails, showAccountDetails, showTransactionHistory, showManageLimit, showTrackLoanClosure, showBenefitsSection, showMyAccountIcon, allowForeclosure, showInterestCalculator, showWithdrawalRejectedCarousal, rejectionDataArray, shouldShowWithdrawalCard, isCreditStatusActive, showHeaderBackButton, hardBreachDate, softBreachDate, showCta, showInfoSection, isLoanExpired));
    },
    actions: {
        [ACTION.DASHBOARD]: withdrawNow,
        [ACTION.REPAYMENT]: repayment,
        [ACTION.MENU]: goBack,
        [ACTION.PROFILE]: OpenProfile,
        [ACTION.CONTACT_US]: OpenContactUS,
        [ACTION.TRANSACTION]: navigate,
        [ACTION.STATUS]: navigateToStatues,
        [ACTION.LEARN_MORE]: learnMoreAction,
        [ACTION.RENEW_NOW]: renewNowAction,
        [ACTION.LOAN_EXPIRED_REPAYMENT]: loanRenewalExpiredRepayment,
        [ACTION.REOPEN_LOAN_ACCOUNT]: reOpenLoanAccount,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.INTEREST_REPAYMENT_DETAILS]: navigateToInterestRepaymentDetials,
        [ACTION.LEARN_MORE_INTEREST]: learnMoreInterest,
        [ACTION.NAV_TO_IC]: navToIC,
        [ACTION.SHORTFALL_DETAILS]: navigateToShortfallDetails,
        [ACTION.NAVIGATE_TO_SHORTFALL_INFO_SCREEN]: navigateToShortfallInfoScreen,
        [ACTION.NAVIGATE_ACCOUNT_DETAILS]: navigateToAccountDetails,
        [ACTION.NAVIGATE_TRANSACTION_DETAILS]: navigateToTransactionHistory,
        [ACTION.NAVIGATE_MANAGE_LIMIT]: navigateToManageLimit,
        [ACTION.NAVIGATE_TRACK_LOAN_CLOSURE]: navigateTrackLoanClosure,
        [ACTION.WITHDRAWAL_REJECTION_TRANSACTION_HISTORY]: navigateToTransactionsPostRejectionAction,
        [ACTION.NAVIGATE_TO_WITHDRAWAL_SCREEN]: navigateToWithdrawalScreenAction,
        [ACTION.CLOSE_SDK_PROCESS_COMPLETE_CARD]: sdkProcessCompleteCardClose,
        [ACTION.ON_WITHDRAW_CLICK_ACTION]: onWithdrawClickAction,
        [ACTION.BACK_BUTTON]: backAction,
        [ACTION.REFUND_LOAN]: loanRefundAction,
    },
    bgColor: `#${getBackgroundColorDashboard()}`,
    clearPrevious: true,
};
